// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Vboo","footer":"styles_footer__32tog","passCodeTooltip":"styles_passCodeTooltip__3Pxxu"};